export function cancel (state) {
	state.status = `CANCELLED`;
}
